const tourSteps = [
    {
      selector: '.region-filter',
      content: 'You can filter in or out any regions by opening up this modal, but do not forget to save your selection before closing it! Quick hint: press escape or click on the greyed out area to end your tour!',
    },
    {
      selector: '.main-chart',
      content: 'Each country is represented by a dot, sized by its population. The grey colored countries are the ones in the Lower and Higher middle income groups, while the Low income countries are colored by the orange, and the High income ones by the blue color. Also, you can hover over the dots if you want to find out more about a country\'s performance! The lower the score of an indicator, the higher the level of overall peacefulness.',
    },
    {
      selector: '.sizer',
      content: 'You can easily change to equal dot sizing by switching off this button!'
    },
    {
      selector: '.year-filter',
      content: 'With the help of this slider, you can filter across all the 12 years in this dataset to see how peacefulness evolved around the globe.',
    },
    {
      selector: '.country-filter',
      content: 'Select the countries you would like to be highlighted in the chart above and added to the linecharts below! You can only select three countries at the same time.',
    },
    {
      selector: '.metric-1',
      content: 'Using the dropdown, you can choose any of the indicators to see what changes they have gone through over time in your selected countries.',
    },
    {
      selector: '.line-chart-1',
      content: 'You can find out more about a country\'s score in a given indicator by hovering over its line, and highlight it across the other indicators by clicking on it!',
    },

  ]

  export { tourSteps }